import { Injectable } from '@angular/core';

export enum CaseType {
  SENTENCE = 'SENTENCE',
  TITLE = 'TITLE',
  CAMEL = 'CAMEL',
  PASCAL = 'PASCAL',
  UPPER = 'UPPER',
  LOWER = 'LOWER'
}

@Injectable({ providedIn: 'root' })
export class CaseFormatService {
  currentCase: CaseType = CaseType.SENTENCE;
}




